import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "../constant/apiConstant";
import { getAnalyticsIdentity } from "../utils/analyticsIdentity";

const track = (payload) => fetch(`${API.BASE_URL}/api/analytics/events`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true }).catch(() => null);

export default function WebsiteAnalytics() {
  const location = useLocation(); const lastRoute = useRef("");
  useEffect(() => {
    const route = location.pathname;
    if (lastRoute.current === route) return;
    lastRoute.current = route;
    const { visitorId, sessionId } = getAnalyticsIdentity();
    track({ event_type: "PAGE_VIEW", visitor_id: visitorId, session_id: sessionId, route });
  }, [location.pathname]);
  useEffect(() => {
    const click = (event) => {
      const link = event.target.closest("a"); if (!link) return;
      const href = link.getAttribute("href") || "";
      if (!href || href.startsWith("#")) return;
      const { visitorId, sessionId } = getAnalyticsIdentity();
      track({ event_type: "LINK_CLICK", visitor_id: visitorId, session_id: sessionId, route: location.pathname, event_name: link.dataset.analytics || href.slice(0, 100) });
    };
    document.addEventListener("click", click); return () => document.removeEventListener("click", click);
  }, [location.pathname]);
  return null;
}
